import { app } from '../../../../app';

app.component('integration', {
    bindings:{
        settings:'<',
    },
    templateUrl: require('./integration.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/company/saaspass-vpn/integration/integration.component.js